
    <div class="flex items-start space-x-2 mb-4">
      <div class="flex items-center">
        <mat-icon
          svgIcon="heroicons_outline:exclamation-triangle"
          class="text-red-500 ml-4 mt-6"
          style="font-size: 32px"
        ></mat-icon>
      </div>
      <div class="grid">
        <h2 mat-dialog-title class="text-lg font-bold mb-1">
          Confirmar eliminación
        </h2>
        <mat-dialog-content class="modal-content mt-0">
          <p>{{confirmationMessage }}</p>
        </mat-dialog-content>
      </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-button mat-dialog-close class="align-left">
        Conservar
      </button>
      <button mat-raised-button color="warn" [mat-dialog-close]="true">
        Eliminar
      </button>
    </mat-dialog-actions>